import PropTypes from 'prop-types';
import { Grid2 } from '@mui/material';

const ContentContainer = ({ children = null }) => <Grid2 size={{ xs: 12, lg: 6, xl: 5 }}>{children}</Grid2>;

ContentContainer.propTypes = {
  children: PropTypes.node,
};
export default ContentContainer;
